<template>
  <DataGetter
    :url="`${apiRoute}/dashboard`"
    :params="{ product, publication, region, flow: ['Headline', 'Paragraph'] }"
    :formatter="formatText"
    v-slot="{ data }"
    class="container"
  >
    <div class="m-block m-block--text">
      <div class="m-block__content f-rte f-rte--block" v-html="data.html"></div>
      <aside class="m-block__aside">
        <h4 class="m-block__title f-title-5">{{ data.headline }}</h4>
      </aside>
    </div>
  </DataGetter>
</template>

<script>
import { DataGetter } from "@international-energy-agency/vue-ui";
export default {
  props: {
    apiRoute: {
      type: String,
      default: "https://api.iea.org/renewables",
    },
    region: {
      type: String,
      required: true,
    },
    product: {
      type: String,
      required: true,
    },
    publication: {
      type: String,
      default: "2023",
    },
  },
  components: { DataGetter },
  methods: {
    formatText(data) {
      return {
        headline: data.find((r) => r.flow === "Headline")?.value,
        html: data.find((r) => r.flow === "Paragraph")?.value,
      };
    },
  },
};
</script>